<template>
  <button
    :disabled="disabled"
    data-cy="create-and-upate-assessment-create-btn"
    :class="`tw-h-[39px] tw-cursor-pointer tw-flex tw-flex-col tw-items-center tw-self-end tw-gap-2.5 tw-px-[18px] tw-rounded-[26.909px] tw-bg-[#387DFF] tw-text-white tw-text-center tw-text-[15px] tw-not-italic tw-font-[500] tw-leading-[100%] ${
      disabled ? 'disabled' : 'hover:tw-bg-[#096cdb]'
    } ${isLoading ? 'tw-overflow-hidden' : 'tw-py-3'} createBtn`"
    @click="onClick"
  >
    <LottieAnimation
      v-if="isLoading"
      :class="`tw-h-[39px] tw-w-[38px] ${classIcon}`"
      :animation-data="ProgressAnimation"
      :auto-play="true"
      :loop="true"
    />
    <div>
      {{ title }}
    </div>
  </button>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import ProgressAnimation from "@/assets/animation/progress_dark.json";

const props = defineProps({
  title: { type: String, required: false, default: "" },
  disabled: { type: Boolean, default: false },
  isLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
  classIcon: {
    type: String,
    required: false,
    default: "",
  },
});

const emits = defineEmits(["click-action"]);

const LottieAnimation: any = ref(null);

onMounted(async () => {
  if (process.env.NODE_ENV === "test") {
    LottieAnimation.value = { render: () => null };
  } else {
    LottieAnimation.value = (await import("lottie-web-vue")).LottieAnimation;
  }
});

const onClick = () => {
  if (props.disabled || props.isLoading) {
    return;
  }
  emits("click-action");
};
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
